import * as React from 'react';

import PreviewItem from '../../Shared/PreviewItem';
import SettingPreview from '../../Shared/SettingPreview';
import type { CompanyFeatureFlagsEntry } from '../formModel';

interface OwnProps {
	toggleEdit: () => void;
	credentials: CompanyFeatureFlagsEntry[];
}

type Props = OwnProps;

const renderItem = (featureFlag: CompanyFeatureFlagsEntry, index: number) => {
	return (
		<PreviewItem
			checked={!!featureFlag.checked}
			hint={featureFlag.hint}
			id={`accqa__notification-settings__automatic__${featureFlag.key}`}
			indent={!!featureFlag.indent}
			key={`${featureFlag.label}${index}`}
			label={featureFlag.label}
			showCheckbox={!!featureFlag.showStatusIcon}
		/>
	);
};

export const CredentialNotificationsPreview: React.FC<Props> = (props) => {
	const { toggleEdit, credentials } = props;

	return (
		<SettingPreview
			buttonContext="notification-settings__automatic"
			containerId="accqa__notification-settings__automatic__container"
			toggleEdit={toggleEdit}
		>
			<div className="company-settings__info-segment">
				{credentials.map(renderItem)}
			</div>
		</SettingPreview>
	);
};

export default React.memo(CredentialNotificationsPreview);
